import './Jobs.scss'

import { getIsMobile } from '@site/js/utils/breakpoint'
import { useContext, useEffect, useState } from 'react'

import { ButtonsWrapper } from '../Components/ButtonsWrapper'
import { FilterableListContext } from '../FilterableListContext'
import { Table } from '../UI/Table'
import { jobsTableHeaders, jobsTableRows } from '../utils/jobs'
import {JobCard} from './JobCard';

export const Jobs = () => {
  const { responseData, translationsState, propsState } = useContext(FilterableListContext)
  const { filterFields, items } = responseData
  const [isMobile, setIsMobile] = useState(getIsMobile())

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile())
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className="cmp-filterable-list">
      {!isMobile && (
      <div className="cmp-filterable-list__table-wrapper">
        <Table
          classNames={'cmp-filterable-list__jobs'}
          tableHeaders={jobsTableHeaders(translationsState, filterFields)}
          tableRows={jobsTableRows(items)}
          componentName={propsState.componentName}
        />
      </div>
       )}
       {isMobile && (
        <div className="cmp-filterable-list__card-wrapper">
  {items.map((item, idx) => (
    <JobCard
      key={idx}
      title={item.title}
      locations={item.location}
      type={item.remoteType || item.jobType}
      experience={item.experience}
      url={item.url}
    />
  ))}
</div>
  )}
      <ButtonsWrapper />
    </div>
  )
}
